import React from 'react';
import { Outlet } from 'react-router-dom';  
import Sidebar from '../SideBar/index.tsx';
import './style.css';

const MainLayout = () => {
  return (
    <div className="page-container">
      <Sidebar className="sidebar" />
      <div className="main-content">
        <Outlet /> 
      </div>
    </div>
  );
};

export default MainLayout;
